module.exports = __webpack_public_path__ + "img/icon_weather_402.5d611b01.svg";